import React, { useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Box,
  Card,
  CardContent,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Snackbar,
  Alert,
} from "@mui/material";
import { useCreateNotificationMutation } from "state/api";

const NotificationForm = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [target, setTarget] = useState("all");
  const [toast, setToast] = useState(null);
  const [createNotification, { isLoading }] = useCreateNotificationMutation();

  const handleSubmit = async () => {
    if (!title.trim()) {
      setToast({ severity: "error", msg: "Title is required" });
      return;
    }
    try {
      await createNotification({ title, description, target }).unwrap();
      setToast({ severity: "success", msg: "Notification sent" });
      handleReset();
    } catch (err) {
      setToast({
        severity: "error",
        msg: err?.data?.error?.message || "Failed to send",
      });
    }
  };

  const handleReset = () => {
    setTitle("");
    setDescription("");
    setTarget("all");
  };

  return (
    <Card variant="outlined" sx={{ mb: 1 }}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <TextField
              label="Title"
              variant="outlined"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel id="target-label">Send To</InputLabel>
              <Select
                labelId="target-label"
                value={target}
                label="Send To"
                onChange={(e) => setTarget(e.target.value)}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="customers">Customers</MenuItem>
                <MenuItem value="staff">Staff</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button variant="outlined" color="error" onClick={handleReset}>
                Reset
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? "Sending…" : "Send Notification"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </CardContent>

      <Snackbar
        open={!!toast}
        autoHideDuration={3000}
        onClose={() => setToast(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        {toast ? (
          <Alert severity={toast.severity} onClose={() => setToast(null)}>
            {toast.msg}
          </Alert>
        ) : null}
      </Snackbar>
    </Card>
  );
};

export default NotificationForm;
